import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { PAYMENTS } = API_ENDPOINTS;

export const paymentsApi = {
  // Won deals with payment status. ?status=pending|recorded, ?q= search.
  getWonPayments: (params) => axiosInstance.get(PAYMENTS.LIST, { params }),

  // Record (or correct) the payment on a won deal sales left pending.
  setPayment: (inquiryId, data) => axiosInstance.patch(PAYMENTS.SET(inquiryId), data),

  // Advance deal: mark the remaining balance collected ({paid, mode}) or undo.
  collectBalance: (inquiryId, data) => axiosInstance.patch(PAYMENTS.BALANCE(inquiryId), data),

  // SUPERADMIN: wipe a wrongly-entered payment. Old values go to the deletion
  // ledger; the deal drops back to awaiting payment. { reason? }
  deletePayment: (inquiryId, data = {}) =>
    axiosInstance.delete(PAYMENTS.SET(inquiryId), { data }),
};
